import { toast } from "sonner";
import { fetchFastApi } from "../../api/fastapi";
import { schemaValidator } from "../../models/schemasV2";
import { Template, UpdateTemplateParams } from "./types";

export const updateSchema = async (
  setTemplate: React.Dispatch<React.SetStateAction<Template | null>>,
  {
    template,
    schemaId,
    name,
    userId,
    deleteTemplate = false,
  }: UpdateTemplateParams,
) => {
  try {
    if (deleteTemplate) {
      await fetchFastApi({
        path: `/schemas/v2/schema/${schemaId}`,
        method: "DELETE",
      });
      return;
    }

    const updatedSchema = schemaValidator.parse({
      ...template,
      id: schemaId,
      name,
      updatedAt: new Date().toISOString(),
    });

    setTemplate((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        name,
        userId,
      };
    });
    await fetchFastApi({
      path: `/schemas/v2/schema/${schemaId}`,
      method: "PUT",
      body: { update_schema: updatedSchema },
    });
    return;
  } catch (error) {
    toast.error("Error updating schema");
    console.error(error);
    throw error;
  }
};
